import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';

@Component({
  selector: 'app-estacao-saiba',
  templateUrl: './estacao-saiba.component.html',
  styleUrls: ['./estacao-saiba.component.scss'],
})
export class EstacaoSaibaComponent implements OnInit {
  private isDesktop: boolean;
  private prefixoRota: string;
  isHybrid = false;
  dica:any = null;

  constructor(
    private platform: Platform,
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {
    this.dica = this.navParams.get('dica');    
  }


  ngOnInit() {
    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.isHybrid = this.platform.is('hybrid');
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
